export const ERROR_UNABLE_READ_PUBLIC_KEY = 'unable-read-public-key';
export const ERROR_UNABLE_READ_PRIVATE_KEY = 'unable-read-private-key';
export const ERROR_FINGERPRINTS_NOT_MATCH = 'fingerprints-not-match';
